<template>
  <div style="width: 100%;height: 100%;">
    <div style="display: flex;margin-top: 10px">
      <div style="width: 250px;margin-top: 0"></div>
      <el-select style="margin-left: 20px;width:250px" v-model="year" @change="initMonthChart" placeholder="年度">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-select style="margin-left: 20px;width:250px" v-model="employeeId" @change="initMonthChart" placeholder="请选择员工">
        <el-option v-for="item in employeeList" :label="item.full_name" :value="item.id" :key="item.full_name"></el-option>
      </el-select>
    </div>
    <!----------------折线图-------------->
    <div style="width: 100%;height: 300px;margin-top: 10px" id="monthMissionChart"/>

    <div style="display: flex;margin-top: 10px">
      <div style="width: 250px;margin-top: 0"></div>
      <el-select style="margin-left: 20px;width:250px" v-model="missionYear" @change="initCompleteChart" placeholder="年度">
        <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <!----------------折线图-------------->
    <div style="width: 100%;height: 300px;margin-top: 10px" id="missionCompleteChart"/>


  </div>

</template>

<script>
import * as echarts from "echarts";
import dayjs from "dayjs";

export default {
  name: "EmployeeKpiMission",
  data() {
    return {
      year:'',
      missionYear:'',
      yearList:[],
      employeeId:'',
      employeeList:[],
      monthSeriesData:[],
      missionXData:[],
      missionSeriesData:[],

    }
  },
  created() {
    this.getYearList();
    this.getEmployeeList();
    this.initMonthChart();
    this.initCompleteChart();

  },

  methods: {

    //获取年数据
    async getYearList(){
      const now = dayjs();
      this.year = now.year()+'';
      this.missionYear = now.year()+'';
      this.yearList = await this.$http('sysDsService.getYears(10,1)')
    },

    async getEmployeeList(){
      this.employeeList = await this.$http('crmTeamService.getAllEmployeeList');
      if(this.employeeList){
        this.employeeId = this.employeeList[0].id;
      }
    },

    async getMissionData(){
      let data = await this.$http('crmMissionService.getMissionData',{year:this.missionYear});
      if(data){
        this.missionSeriesData = data.seriesData;
        this.missionXData = data.xData;
      }

    },

    async initMonthChart(){
      await this.getMonthData();
      await this.monthEcharts();
    },
    async getMonthData(){
      let params = {
        employeeId:this.employeeId,
        year:this.year
      }

      this.monthSeriesData = await this.$http('crmMissionService.getMonthData', params);

    },

    async monthEcharts() {
      const chartDom = document.getElementById('monthMissionChart');

      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(chartDom);

      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }

      // 初始化新的 ECharts 实例
      myChart = echarts.init(chartDom);
      myChart.setOption(this.getMonthOptions(), true);
    },
    getMonthOptions(){
      console.log('22222==',this.monthSeriesData)
      return {
        title: {
          left: 'left',
          text: '单月任务进度数据'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['任务套数', '折算套数']
        },
        xAxis: {
          type: 'category',
          data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月','八月', '九月', '十月', '十一月', '十二月'],
          axisPointer: {
            type: 'shadow'
          }
        },
        yAxis: {
          type: 'value',
        },
        series: this.monthSeriesData === undefined ? [] : this.monthSeriesData,
      }
    },

    async initCompleteChart(){
      await this.getMissionData();
      await this.completeEcharts();
    },
    async completeEcharts() {
      const chartDom = document.getElementById('missionCompleteChart');

      // 获取现有的 ECharts 实例（如果有）
      let myChart = echarts.getInstanceByDom(chartDom);

      // 如果存在现有的实例，销毁它
      if (myChart) {
        myChart.dispose();
      }

      // 初始化新的 ECharts 实例
      myChart = echarts.init(chartDom);
      myChart.setOption(this.getCompleteOptions(), true);
    },
    getCompleteOptions(){
      return {
        title: {
          left: 'left',
          text: '员工任务详情'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['任务套数', '销售折算套数']
        },
        xAxis: {
          type: 'category',
          data: this.missionXData === undefined ? [] : this.missionXData,
          axisPointer: {
            type: 'shadow'
          }
        },
        yAxis: {
          type: 'value',
        },
        series: this.missionSeriesData === undefined ? [] : this.missionSeriesData,
      }
    },

  },
}
</script>

<style scoped>


</style>